import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepClaimSummary.sectionTitle',
    defaultMessage: 'Section 11 - Claim Summary',
  },
  title: {
    id: 'fastCover.stepClaimSummary.title',
    defaultMessage: 'Title',
  },
  firstName: {
    id: 'fastCover.stepClaimSummary.firstName',
    defaultMessage: 'First Name(s)',
  },
  surname: {
    id: 'fastCover.stepClaimSummary.surname',
    defaultMessage: 'Surname',
  },
  dateOfBirth: {
    id: 'fastCover.stepClaimSummary.dateOfBirth',
    defaultMessage: 'Date of Birth',
  },
  address: {
    id: 'fastCover.stepClaimSummary.address',
    defaultMessage: 'Address',
  },
  addressLine1: {
    id: 'fastCover.stepClaimSummary.addressLine1',
    defaultMessage: 'Address Line 1',
  },
  addressLine2: {
    id: 'fastCover.stepClaimSummary.addressLine2',
    defaultMessage: 'Address Line 2',
  },
  city: {
    id: 'fastCover.stepClaimSummary.city',
    defaultMessage: 'City',
  },
  stateProvinceRegion: {
    id: 'fastCover.stepClaimSummary.stateProvinceRegion',
    defaultMessage: 'State / Province / Region',
  },
  postalZipCode: {
    id: 'fastCover.stepClaimSummary.postalZipCode',
    defaultMessage: 'Postal / Zip Code',
  },
  mobile: {
    id: 'fastCover.stepClaimSummary.mobile',
    defaultMessage: 'Phone Number',
  },
  homePhone: {
    id: 'fastCover.stepClaimSummary.homePhone',
    defaultMessage: 'Home Phone Number',
  },
  workPhone: {
    id: 'fastCover.stepClaimSummary.workPhone',
    defaultMessage: 'Work Phone Number',
  },
  email: {
    id: 'fastCover.stepClaimSummary.email',
    defaultMessage: 'Email',
  },
  preferredContactNumberForClaim: {
    id: 'fastCover.stepClaimSummary.preferredContactNumberForClaim',
    defaultMessage: 'Preferred Contact Number for Claim',
  },
  preferredContactForClaim: {
    id: 'fastCover.stepClaimSummary.preferredContactForClaim',
    defaultMessage: 'Preferred Contact for Claim',
  },
  preferredContactEmailForClaim: {
    id: 'fastCover.stepClaimSummary.preferredContactEmailForClaim',
    defaultMessage: 'Preferred Contact Email for Claim',
  },
  occupation: {
    id: 'fastCover.stepClaimSummary.occupation',
    defaultMessage: 'Occupation',
  },
  policyNumber: {
    id: 'fastCover.stepClaimSummary.policyNumber',
    defaultMessage: VARS.MESSAGE.auth.policyNumber,
  },
  dateBookedTrip: {
    id: 'fastCover.stepClaimSummary.dateBookedTrip',
    defaultMessage: 'Date I booked my trip',
  },
  dateScheduledToDepart: {
    id: 'fastCover.stepClaimSummary.dateScheduledToDepart',
    defaultMessage: 'Date I was originally scheduled to depart on my Trip',
  },
  dateOriginallyScheduled: {
    id: 'fastCover.stepClaimSummary.dateOriginallyScheduled',
    defaultMessage: 'Date I was originally scheduled to return home',
  },
  plannedDestination: {
    id: 'fastCover.stepClaimSummary.plannedDestination',
    defaultMessage: 'Planned destination(s)',
  },
  totalAmountPaidInAud: {
    id: 'fastCover.stepClaimSummary.totalAmountPaidInAud',
    defaultMessage:
      'Total amount of pre-paid travel expenses (in Australian dollars)',
  },
  countryRegionCity: {
    id: 'fastCover.stepClaimSummary.countryRegionCity',
    defaultMessage: 'Country, region, city, etc.',
  },
  reasonForTrip: {
    id: 'fastCover.stepClaimSummary.reasonForTrip',
    defaultMessage: 'Reason for Trip',
  },
  holiday: {
    id: 'fastCover.stepClaimSummary.holiday',
    defaultMessage: 'Holiday',
  },
  visitingFamilyOrFriend: {
    id: 'fastCover.stepClaimSummary.visitingFamilyOrFriend',
    defaultMessage: 'Visiting Family or Friends',
  },
  business: {
    id: 'fastCover.stepClaimSummary.business',
    defaultMessage: 'Business',
  },
  other: {
    id: 'fastCover.stepClaimSummary.other',
    defaultMessage: 'Other',
  },
  doYouHaveAnotherOtherInsurance: {
    id: 'fastCover.stepClaimSummary.doYouHaveAnotherOtherInsurance',
    defaultMessage:
      'Do you have any other insurance that would cover all or part of your loss?',
  },
  yes: {
    id: 'fastCover.stepClaimSummary.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepClaimSummary.no',
    defaultMessage: 'No',
  },
  exampleHomeContentsInsurance: {
    id: 'fastCover.stepClaimSummary.exampleHomeContentsInsurance',
    defaultMessage:
      'e.g. Home Contents insurance, Private Health Fund, Credit Card',
  },
  wouldYouLikeToGivePermission: {
    id: 'fastCover.stepClaimSummary.wouldYouLikeToGivePermission',
    defaultMessage:
      'Would you like to give permission for a Third Party to manage this claim on your behalf?',
  },
  ifYesPleaseProvideDetails: {
    id: 'fastCover.stepClaimSummary.ifYesPleaseProvideDetails',
    defaultMessage: 'If yes, please provide details',
  },
  thirdPartyAuthority: {
    id: 'fastCover.stepClaimSummary.thirdPartyAuthority',
    defaultMessage: 'Third Party Authority',
  },
  relationshipToYou: {
    id: 'fastCover.stepClaimSummary.relationshipToYou',
    defaultMessage: 'Relationship to you',
  },
  isRequired: {
    id: 'fastCover.stepClaimSummary.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  isMaxLength: {
    id: 'fastCover.stepClaimSummary.isMaxLength',
    defaultMessage: "'{defaultMessage}' maximum length has been exceeded",
  },
  isValid: {
    id: 'fastCover.stepClaimSummary.isValid',
    defaultMessage: "'{defaultMessage}' is invalid",
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepClaimSummary/messages.js